import { Box, CircularProgress } from '@mui/material';
import React from 'react';

export default function Component(props) {
  const {
    full, used, total, size = 32, thickness = 5, classes,
  } = props;
  return (
    <Box position="relative" alignSelf="center" display="inline-flex" className={classes.root}>
      <CircularProgress
        className="bg-progress"
        variant="determinate"
        value={100}
        size={size}
        thickness={thickness}
      />
      <CircularProgress
        className={full ? 'red-progress' : 'green-progress'}
        variant="determinate"
        value={(used / total) * 100}
        size={size}
        thickness={thickness}
        sx={{ position: 'absolute', left: 0 }}
      />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
        fontSize={8}
        color={full ? '#FD6969' : '#38AC3D'}
        fontWeight="700"
      >
        {Math.ceil((used / total) * 100)}
        %
      </Box>
    </Box>
  );
}
